import React from 'react';
import { TruncatedCopy } from 'common/Text/TruncatedCopy';
import styled from 'styled-components';
import { JobFamilyGroupModel } from '@utmost.co/enterprise-models';
import { DataTableTypes } from '@utmost.co/utmost-design-system';
import { useDeepMemo } from '@beeline.com/bp-design-system';
import { JobFamilyGroupActions } from './JobFamilyGroupActions';
import { useJobFamilyGroupsIntl } from './translations/useJobFamilyGroupsIntl';

interface ColumnsProps {
  onUpdated: (uid: string) => void;
  onDeleteAll: (uids: string[]) => void;
}

export const useJobFamilyGroupColumns = ({
  onUpdated,
  onDeleteAll
}: ColumnsProps): DataTableTypes.Column<JobFamilyGroupModel>[] => {
  const intl = useJobFamilyGroupsIntl();

  return useDeepMemo(
    (): DataTableTypes.Column<JobFamilyGroupModel>[] => [
      {
        accessor: 'name',
        Header: intl.name,
        Cell: ({ value }) => <span data-test="family-group-name">{value}</span>
      },
      {
        accessor: 'referenceId',
        Header: intl.referenceId,
        ellipsisOnOverflow: false,
        Cell: ({ value }) => (
          <StyledReferenceId data-test="family-group-ref-id">
            <TruncatedCopy textCopy={value ?? '-'} />
          </StyledReferenceId>
        )
      },
      {
        id: '[menu]',
        Header: '',
        sticky: 'right',
        accessor: (jobFamilyGroup) => (
          <JobFamilyGroupActions
            jobFamilyGroup={jobFamilyGroup}
            data-test="job-family-group-actions"
            onUpdated={onUpdated}
            onDeleteAll={onDeleteAll}
          />
        )
      }
    ],
    [intl, onUpdated, onDeleteAll]
  );
};

const StyledReferenceId = styled.span`
  width: 100%;
`;
